"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var utils_1 = require("../../../utils");
var RegExpUtils_1 = require("../../../utils/RegExpUtils");
var NUMBER_REGEXP = /^([-]?[0-9]+)([,.][0-9]+)?$/;
exports.numberValidator = {
    name: 'number',
    validation: function (value) {
        var valueWithoutWhitespace = utils_1.isDefined(value) ? String(value).replace(RegExpUtils_1.WHITESPACE_PATTERN, '') : value;
        return utils_1.isEmpty(valueWithoutWhitespace) || NUMBER_REGEXP.test(valueWithoutWhitespace);
    },
    formatter: function (value) {
        var newValue = value.replace('.', ',').replace(RegExpUtils_1.WHITESPACE_PATTERN, '');
        var _a = newValue.split(','), _b = _a[0], integers = _b === void 0 ? '' : _b, _c = _a[1], decimals = _c === void 0 ? '' : _c;
        if (integers.length > 0) {
            var formattedIntegers = integers.replace(RegExpUtils_1.FORMAT_3_DIGITS_GROUPS, ' ');
            newValue = formattedIntegers;
        }
        if (decimals.length > 0) {
            newValue = newValue + "," + decimals;
        }
        return newValue;
    },
};
//# sourceMappingURL=NumberValidator.js.map